/**
 * Normalize a location's `state` field to a canonical form so the union
 * counts on TWMA / Locations pages don't double-count "MI" and "Michigan"
 * or a trailing-space variant like "IL ".
 *
 * Reads the US_STATES map from OpenStorePage to keep a single source of
 * truth for name ↔ abbreviation mapping.
 */
import { US_STATES } from "@/pages/public/OpenStorePage";

// Build once at module load — { al: "Alabama", alabama: "Alabama", ... }
const CANONICAL_BY_TOKEN = (() => {
  const map = {};
  Object.values(US_STATES).forEach((s) => {
    const canonical = s.name;
    map[s.name.toLowerCase()] = canonical;
    map[s.abbr.toLowerCase()] = canonical;
  });
  return map;
})();

export function normalizeStateName(raw) {
  if (!raw) return "";
  const key = String(raw).trim().toLowerCase();
  return CANONICAL_BY_TOKEN[key] || String(raw).trim();
}

/**
 * Given a list of records with a `state` field, return the count of
 * distinct canonical state names present.
 */
export function distinctStateCount(records) {
  const seen = new Set();
  (records || []).forEach((r) => {
    const c = normalizeStateName(r?.state);
    if (c) seen.add(c);
  });
  return seen.size;
}

/**
 * Same idea but returns the sorted list of canonical names.
 */
export function distinctStateNames(records) {
  const seen = new Set();
  (records || []).forEach((r) => {
    const c = normalizeStateName(r?.state);
    if (c) seen.add(c);
  });
  return Array.from(seen).sort();
}
